import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { StyledError } from '../../../theme/components/StyledError'
import { useContractenSearch } from '../hooks/useContractenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

import { Contract } from './Contract'

export { ContractinstellingenContracten }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenContracten = ({ filters }: Props) => {
  const {
    data: contracten,
    isLoading,
    error,
  } = useContractenSearch({ externalFilters: filters })

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Box>
        {contracten
          .sort((a, b) => a.gebiedscodeLabel.localeCompare(b.gebiedscodeLabel))
          .map((contract) => (
            <Contract
              expanded
              contract={contract}
              key={contract.combi + contract.gebiedscode}
            />
          ))}
      </Box>

      {!isLoading && contracten.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
